import { useEffect, useState } from "react";
import API from "../services/api-request";
import SelectWarehouse from "./SelectWarehouse";
import { Spin } from "antd";

const SelectLayout = ({ value, onChange }) => {
  const [selectedWarehouse, setSelectedWarehouse] = useState(1);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);

  const onSelectWarehouse = (value) => {
    setSelectedWarehouse(value);
  };

  const getData = async () => {
    setLoading(true);
    API.Get(`area/map?warehouseId=${selectedWarehouse}`)
      .then((res) => {
        setLoading(false);

        console.log(res?.data);
        setData(res?.data);
      })
      .catch((err) => console.log(err))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    getData();
  }, [selectedWarehouse]);

  return (
    <div style={{ padding: "16px" }}>
      <SelectWarehouse onChange={onSelectWarehouse} value={selectedWarehouse} />
      {loading ? <Spin /> : data?.map((warehouse) => (
        <div key={warehouse.warehouse_id} style={{ marginBottom: "24px" }}>
          {warehouse.sections.map((section) => (
            <div key={section.section} style={{ marginBottom: "16px" }}>
              <h3
                style={{
                  fontSize: "18px",
                  fontWeight: "bold",
                  marginBottom: "8px",
                }}
              >
                Section {section.section}
              </h3>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(12, 1fr)",
                  gap: "16px",
                }}
              >
                {section.rows.map((row) =>
                  row.columns.map((column) =>
                    column.levels.map((level) => (
                      <div
                        key={level.id}
                        style={{
                          padding: "16px",
                          border: "1px solid #ccc",
                          borderRadius: "8px",
                          textAlign: "center",
                          cursor: "pointer",
                          transition: "all 0.3s",
                          backgroundColor:
                            value === level.id ? "#007bff" : "#e0e0e0",
                          color: value === level.id ? "#fff" : "#000",
                        }}
                        onClick={() =>
                          onChange({
                            id: level.id,
                            warehouse_name: warehouse.warehouse_name,
                            name: level.name,
                            level: level.level,
                          })
                        }
                      >
                        {level.name} ({level.level})
                      </div>
                    ))
                  )
                )}
              </div>
            </div>
          ))}
        </div>
      ))}
    </div>
  );
};

export default SelectLayout;
